import React from "react";
import Hero from "../components/Hero";
import About from "../components/About";
import TechStack from "../components/TechStack";
// import Projects from "../components/Projects";
// import Blog from "../components/Blog";
import Contact from "../components/Contact";

const Home = () => {
  return (
    <main>
      <Hero />
      <About />
      <TechStack />
      <Contact />
    </main>
  );
};

export default Home;
